import './Contato.css';
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import BannerHomePhone from '../../Banners/BannerHomePhone/BannerHomePhone.js'
import Button from '../../Button/button';
import iconeWhatsapp from '../../../imgs/whatsapp.png'

const numero = ["5519999704608"]

function getRandomWpp() {
    let rand = Math.floor(Math.random() * numero.length);
    let number = numero[rand];
    // console.log(number);
    window.location = `https://api.whatsapp.com/send?phone=${number}&text=Olá!%20Gostaria%20de%20continuar%20o%20atendimento%20sobre%20o%20empréstimo%20na%20conta%20de%20luz`
}

function Contato() {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(true)
    const nomeUsuario = sessionStorage.getItem("nomeUsuario")


    return (
        <div className="home">
            <div className='backgroundLateral'></div>
            <div>
                <div className='informacoesAguarde2'>
                    <div className='informacoes_recebidas2'>{nomeUsuario != null ? nomeUsuario + ", vamos": "Vamos"} precisar de mais algumas informações para continuar com o seu pedido.</div>
                    <h3 className='informacoesH4'>Clique no botão abaixo e fale com um atendente agora mesmo:</h3>
                    <div className='cb'></div>

                    <div className='btnRodape'>
                        <button onClick={getRandomWpp} className='btnContinuar4' cursor='pointer'>FALE AGORA</button>
                    </div>
                </div>
            </div>
            <div className='backgroundLateral'></div>
        </div>
    );
}

export default Contato;
